import { PhotoOutline } from '@travel/icons/ui';
import { cx } from '@travel/utils';
import styles from './noImageContent.module.scss';

type Props = {
  mediaWrapperClassName?: string;
};

const NoImageContent = (props: Props) => {
  const { mediaWrapperClassName } = props;
  return (
    <div className={cx(mediaWrapperClassName, styles.noImage)}>
      <div className={styles.noImageContent}>
        <PhotoOutline color="currentColor" />
        <p className={styles.noImageTitle}>No image</p>
      </div>
    </div>
  );
};

export default NoImageContent;
